import { ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { Messages } from 'src/app/constants/messages';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-error-codes-modal',
  templateUrl: './error-codes-modal.component.html',
  styleUrls: ['./error-codes-modal.component.css']
})
export class ErrorCodesModalComponent implements OnInit, OnDestroy {

  @ViewChild("values", { static: false }) valueRef: ElementRef | undefined;

  @Input() errorCodeData: any;
  @Input() errorCodeAdd: any;
  @Input() errorCodeView: any;
  @Input() errorCodeEdit: any;

  errorCodeForm: FormGroup;
  formSubmitted: boolean = false;
  errorMessage: any = null;
  private _loading: boolean = false;
  private _afterClosedSubscription: Subscription;
  private _saveErrorCodeSubscription: Subscription;
  
  constructor(
    private _activeModal: NgbActiveModal,
    private _fb: FormBuilder,
    private _service: ServicecallService,
    private _dialog: MatDialog
  ) {
    this.errorCodeForm = this._fb.group({
      errorCode: ['', [Validators.required,Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/)]],
      description: ['', [Validators.required,Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/)]]
    });
  }

  ngOnInit(): void {
    this._loadModalData();
  }
  ngOnDestroy(): void {
    this._afterClosedSubscription?.unsubscribe();
    this._saveErrorCodeSubscription?.unsubscribe();  
  }
  closeModal() {
    if (this.errorCodeForm.dirty) {
      let dialogRef = this._dialog.open(AlertDialogComponent, {
        data: {msg:Messages.UNSAVED_CHANGES,type:null},
        disableClose: true
      });
      this._afterClosedSubscription = dialogRef.afterClosed().subscribe(result => {
        if(result){
          this._activeModal.close();
        }
      });
    }
    else {
      this._activeModal.close();
    }
  }
  onSubmit() {
    this.formSubmitted = true;
    if (this.errorCodeForm.invalid) {
      return;
    }
    this._saveErrorCode();
  }

  get formValues() {
    return this.errorCodeForm.controls;
  }
  private _loadModalData() {
    if (this.errorCodeData) {
      if (this.errorCodeView) {
        this.errorCodeForm.disable();
      }
    }
    this._patchValues();
  }
  private _patchValues() {
    if (this.errorCodeAdd) {
      this.errorCodeForm.patchValue({ errorCode: this.errorCodeForm.value.errorCode, description: this.errorCodeForm.value.description });
    } else {
      this.errorCodeForm.patchValue({
        errorCode: this.errorCodeData.errorCode, description: this.errorCodeData.description
      });
    }
  }
  private _saveErrorCode() {
    this.errorMessage = null;
    if (this.errorCodeForm.invalid) {
      return;
    }
    this._loading = true;
    this.errorCodeForm.value.group = "system";
    let errorData;
    if (this.errorCodeAdd) {
      errorData = { set: this.errorCodeForm.value };
    } else {
      if (!this.errorCodeForm.controls['description'].dirty) {
        this.errorCodeForm.value.description = null;
        this.errorCodeForm.controls['description'].clearValidators();
      }
      if (!this.errorCodeForm.controls['errorCode'].dirty) {
        this.errorCodeForm.value.roleName = null;
        this.errorCodeForm.controls['errorCode'].clearValidators();
      }
      errorData = { errorCodeId: this.errorCodeData["_id"], set: this.errorCodeForm.value };
    }
    this._saveErrorCodeSubscription = this._service.saveErrorCode(errorData).subscribe((result: any) => {
      if (result["status"] && result["response"]) {
        if (result["status"]) {
          this._service.toasterService({ type: 'success', msg: result['response']['message'] });
          this._loading = false;
          this._activeModal.close(true);
        } else {
          this.errorMessage = result['response']['message'] + ' - ' + result['response']['error'];
          // this.service.toasterService({ type: 'error', msg: result['response']['message'] });
          this._loading = false;
        }
      } else {
        if (result["response"]) {
          this.errorMessage = result['response']['message'] + ' - ' + result['response']['error'];
          // this.service.toasterService({ type: 'error', msg: result['response']['message'] });
          this._loading = false;
        }
      }
    });
  }

}
